import ReactDOM from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';
import App from '../components/App';
import { AutoLockProvider } from '../contexts/AutoLockContext';
import { CacheControlProvider } from '../contexts/CacheControlContext';
import store from '../components/store';

import '../assets/scss/app.scss';
import { ThemeProvider } from '@material-ui/core';
import { mainTheme } from '../theme';

function RootComponent() {
  return (
    <ReduxProvider store={store}>
      <ThemeProvider theme={mainTheme}>
        <div className="load" id="app-loading">
          <div className="material-loading">
            <svg className="load-icon">
              <circle cx="25" cy="25" r="20" fill="none" strokeWidth="6" strokeMiterlimit="10" />
            </svg>
          </div>
        </div>
        {/*loader */}

        <CacheControlProvider>
          <AutoLockProvider>
            <App />
          </AutoLockProvider>
        </CacheControlProvider>
      </ThemeProvider>
    </ReduxProvider>
  );
}

ReactDOM.createRoot(document.getElementById('root')).render(<RootComponent />);
